export default "__VITE_ASSET__CgWnoyVd__"